import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import { Platform } from "../../Utils/Const";
import api from "../../Utils/Api";
import { baseapi } from "../../Environmentalurl";

export default function KycStatus() {
  const [searchParams] = useSearchParams();
  const txnId = searchParams.get("txnId");
  const [status, setStatus] = useState("LOADING");
  const navigate = useNavigate();

  useEffect(() => {
    const processKyc = async () => {
      try {
        const step = localStorage.getItem("kycStep");

        // =====================================
        // 🔥 CASE 0: AFTER ESETU → GO TO PAN
        // =====================================
        if (step === "AFTER_ESETU") {
          console.log("👉 AFTER ESETU → PAN FLOW");

          localStorage.removeItem("kycStep");

          navigate("/kyc-status/pan"); // ✅ PAN FLOW START
          return;
        }

        // =====================================
        // 🔥 NORMAL FLOW START
        // =====================================
        if (!txnId) return;

        console.log("👉 Step 1: processFlow");

        const res1 = await api.get(
          `${baseapi}/vciptransidcallbackurl/processFlow/${txnId}`,
        );

        const aadhaarData = res1.data?.responseData;

        if (!aadhaarData) {
          setStatus("FAILED");
          return;
        }

        // =====================================
        // 🔥 GET MOBILE
        // =====================================
        const mobile = sessionStorage.getItem("mobileNumber");

        if (!mobile) {
          setStatus("FAILED");
          return;
        }

        // =====================================
        // 🔥 STEP 2: GetVerificationStatus
        // =====================================
        console.log("👉 Step 2: GetVerificationStatus");

        const res2 = await api.post(
          "https://staging.transactionanalysts.com:444/VCIP/vcip/AccountHolder/GetVerificationStatus",
          {
            mobileNumber: mobile,
            EntityID: 65,
            platformId: Platform,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "X-Company-Code": "TA001",
            },
          },
        );

        const data = res2.data?.data;

        if (!data) {
          setStatus("FAILED");
          return;
        }

        const { poiVerified, poaVerified } = data;

        // =====================================
        // ✅ CASE 1: BOTH TRUE → FINAL REDIRECT
        // =====================================
        if (poaVerified && poiVerified) {
          console.log("✅ BOTH VERIFIED");

          const url = data?.url;

          if (url) {
            window.location.href = url;
          } else {
            setStatus("FAILED");
          }
          return;
        }

        // =====================================
        // ✅ CASE 2: BOTH FALSE → Aadhaar → PAN
        // =====================================
        if (!poaVerified && !poiVerified) {
          console.log("👉 BOTH FALSE → Aadhaar API");

          const aadhaarRes = await api.post(
            "https://staging.transactionanalysts.com:444/VCIP/vcip/AccountHolder/UpdateAadhaarDetails",
            {
              mobileNumber: mobile,
              poa: aadhaarData.uidNo,
              poiname: aadhaarData.citizenName,
              poaType: "Aadhaar",
              poaVerified: true,
              photo: aadhaarData.photographPath,
              poaco: aadhaarData.careOf,
              poahouse: aadhaarData.locality,
              poastreet: aadhaarData.street,
              poaloc: aadhaarData.stateName,
              poavtc: aadhaarData.vtc,
              poasubdist: aadhaarData.districtName,
              poastate: aadhaarData.stateName,
              poapc: aadhaarData.pinCode,
              poalm: aadhaarData.landMark,
              poidob: aadhaarData.dob,
              gender: aadhaarData.gender,
              machineID: "ANDROID-PIXEL-7",
            },
            {
              headers: {
                "X-Company-Code": "TA001",
              },
            },
          );

          if (aadhaarRes.data?.resCode === "000") {
            console.log("✅ Aadhaar Done → Go PAN");

            sessionStorage.setItem(
              "aadhaarData",
              JSON.stringify({
                citizenName: aadhaarData.citizenName,
                dob: aadhaarData.dob,
              }),
            );

            navigate("/kyc-status/pan");
            return;
          } else {
            setStatus("FAILED");
            return;
          }
        }

        // =====================================
        // ✅ CASE 3: POA TRUE, POI FALSE
        // 👉 DIRECT USER DETAILS
        // =====================================
        if (poaVerified && !poiVerified) {
          console.log("👉 POI PENDING → GO TO PAN FLOW");

          // ✅ Aadhaar data store (PAN API kosam)
          sessionStorage.setItem(
            "aadhaarData",
            JSON.stringify({
              citizenName: aadhaarData.citizenName,
              dob: aadhaarData.dob,
            }),
          );

          // ✅ direct PAN page ki velthundi
          navigate("/kyc-status/pan");

          return;
        }

        setStatus("FAILED");
      } catch (err) {
        console.error(err);
        setStatus("FAILED");
      }
    };

    processKyc();
  }, [txnId]);

  return (
    <Box textAlign="center" mt={10}>
      {status === "LOADING" && (
        <>
          <CircularProgress />
          <Typography mt={2}>Processing KYC...</Typography>
        </>
      )}

      {status === "SUCCESS" && (
        <Typography color="green" variant="h5">
          KYC Success ✅
        </Typography>
      )}

      {status === "FAILED" && (
        <Typography color="red" variant="h5">
          KYC Failed ❌
        </Typography>
      )}
    </Box>
  );
}
